import { render, staticRenderFns } from "./AgendaDateComponent.vue?vue&type=template&id=8cfb57f0&scoped=true"
import script from "./AgendaDateComponent.vue?vue&type=script&lang=js"
export * from "./AgendaDateComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaDateComponent.vue?vue&type=style&index=0&id=8cfb57f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfb57f0",
  null
  
)

export default component.exports